export default requester => {
    return {
        /**
         * Get revisions by object
         * 
         * @param {string} objectType
         * @param {string} objectId
         * @param {object} params Query parameters
         * @returns
         */
        byObject(objectType, objectId, params = {}) {
            return requester.get(`/revisions/${objectType}/${objectId}`, { params });
        }
    };
}
